// Welcome discount pop-up behaviour (markup in blocks/discount-popup.liquid).
// - Opens after the configured delay once per visit (browser session), including for past sign-ups.
// - Closing it keeps it closed for the rest of that visit; it opens again next visit.
// - A small corner tab lets shoppers reopen the offer at any time.
// - The "email already used" check on submit (further down) is unchanged.
// - After the sign-up form posts, Shopify reloads with ?customer_posted=true#discount-popup-form,
//   so the pop-up reopens on the success step.
const dialog = document.querySelector('[data-discount-popup]');

if (dialog && typeof dialog.showModal === 'function') {
  const CLAIMED_KEY = 'treasure9:popup-claimed';
  const VISIT_DISMISSED_KEY = 'treasure9:popup-dismissed-this-visit';
  const delay = Number(dialog.dataset.delay || 5) * 1000;
  const designMode = dialog.dataset.designMode === 'true';
  const tab = document.querySelector('[data-popup-tab]');

  const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch { /* storage blocked */ } };
  const readVisit = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const writeVisit = (key, value) => { try { sessionStorage.setItem(key, value); } catch { /* storage blocked */ } };

  // Clear the old 7-day dismissal so returning shoppers see the offer again.
  try { localStorage.removeItem('treasure9:popup-dismissed'); } catch { /* ignore */ }

  const isClaimed = () => Boolean(read(CLAIMED_KEY)) || dialog.dataset.claimed === 'true';

  const showStep = (name) => {
    dialog.querySelectorAll('[data-popup-step]').forEach((step) => { step.hidden = step.dataset.popupStep !== name; });
  };

  const updateTab = () => {
    if (!tab) return;
    tab.hidden = dialog.open;
  };

  const open = () => {
    if (!dialog.open) dialog.showModal();
    updateTab();
  };

  const params = new URLSearchParams(window.location.search);
  const justSignedUp = params.get('customer_posted') === 'true' && window.location.hash === '#discount-popup-form';
  const hasError = !justSignedUp && window.location.hash === '#discount-popup-form' && dialog.querySelector('[role="alert"]');
  const forcePreview = params.get('popup') === 'preview';

  if (justSignedUp) {
    write(CLAIMED_KEY, '1');
    showStep('success');
    open();
  } else if (hasError || forcePreview) {
    showStep('signup');
    open();
  } else if (designMode) {
    // In the editor, show it once per session so it can be found and edited without blocking every page.
    if (!readVisit('treasure9:popup-design-seen')) {
      writeVisit('treasure9:popup-design-seen', '1');
      setTimeout(open, 1500);
    }
  } else {
    const dismissedThisVisit = readVisit(VISIT_DISMISSED_KEY);
    const onCart = document.querySelector('main[data-template="cart"]');
    if (!dismissedThisVisit && !onCart) setTimeout(open, delay);
  }

  updateTab();

  // Closing hides it for the rest of this visit only.
  dialog.addEventListener('close', () => {
    writeVisit(VISIT_DISMISSED_KEY, '1');
    updateTab();
  });

  // Close when clicking the dimmed backdrop.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  // Corner tab reopens the sign-up step.
  tab?.addEventListener('click', () => {
    showStep('signup');
    open();
  });

  // Copy the code.
  const copyButton = dialog.querySelector('[data-popup-copy]');
  const codeEl = dialog.querySelector('[data-popup-code]');
  const status = dialog.querySelector('[data-popup-copy-status]');
  copyButton?.addEventListener('click', async () => {
    const code = codeEl?.textContent.trim();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      const range = document.createRange();
      range.selectNodeContents(codeEl);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand?.('copy');
    }
    const original = copyButton.textContent;
    copyButton.textContent = dialog.dataset.copiedLabel || 'Copied!';
    if (status) status.textContent = dialog.dataset.copiedLabel || 'Copied!';
    setTimeout(() => { copyButton.textContent = original; }, 2000);
  });

  // Editor support: open when the block is selected in the editor.
  document.addEventListener('shopify:block:select', (event) => {
    if (dialog.contains(event.target) || event.target === dialog) open();
  });
}

// "Email already used" check: remembers (hashed) emails entered on this device and blocks re-use.
// Shopify Flow separately guarantees each email only ever receives one code.
{
  const popup = document.querySelector('[data-discount-popup]');
  const form = popup?.querySelector('#discount-popup-form');
  const emailInput = form?.querySelector('input[type="email"]');
  const usedMessage = popup?.querySelector('[data-popup-used]');
  const EMAILS_KEY = 'treasure9:popup-emails';

  const hashEmail = async (email) => {
    const normalized = email.trim().toLowerCase();
    try {
      const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized));
      return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, '0')).join('');
    } catch {
      return normalized;
    }
  };
  const readList = () => { try { return JSON.parse(localStorage.getItem(EMAILS_KEY) || '[]'); } catch { return []; } };
  const writeList = (list) => { try { localStorage.setItem(EMAILS_KEY, JSON.stringify(list)); } catch { /* storage blocked */ } };

  emailInput?.addEventListener('input', () => {
    if (usedMessage) usedMessage.hidden = true;
    emailInput.removeAttribute('aria-invalid');
  });

  let verified = false;
  form?.addEventListener('submit', async (event) => {
    if (verified || !emailInput?.value) return;
    event.preventDefault();
    const hash = await hashEmail(emailInput.value);
    const list = readList();
    if (list.includes(hash) || popup.dataset.claimed === 'true') {
      if (usedMessage) usedMessage.hidden = false;
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.focus();
      return;
    }
    list.push(hash);
    writeList(list);
    verified = true;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
}
